import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStartCheckout2TB } from '../hooks/useStartCheckout2TB';
import InAppBrowserWarning from '../components/InAppBrowserWarning';

// Reached whenever App.js's buyIntent is set (see its page==='post-register'
// branch) — someone who clicked a "buy" button anywhere on the site (hero,
// plans-section cards, promo banner) before they had an account. Every one
// of those entry points passes its own {plan, campaign} through
// registration; this fires the SAME checkout call the button would have
// made directly if they'd already been logged in, automatically, on mount —
// no free/upgrade choice shown, because they already made that choice.
// The in-app-browser warning still shows here if needed (via
// useStartCheckout2TB) — this never skips that safety net, it only skips
// the free-vs-upgrade question. `plan` defaults to 'lifetime_2tb' for the
// original hero_buy callers that don't pass it explicitly.
export default function AutoCheckoutPage({ campaign, plan = 'lifetime_2tb', onFallbackFree }) {
  const { t } = useTranslation('postRegister');
  const { buy2tb, loading, error, saltoInCorso, inAppWarningProps } = useStartCheckout2TB(campaign, plan);

  useEffect(() => {
    buy2tb();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="pru-page">
      <div className="pru-card" style={{ textAlign: 'center' }}>
        {!error && (
          <>
            {/* Mentre si apre Chrome, Facebook mostra una sua finestrella
                ("Vuoi uscire dal sito?"). Non si puo' togliere da qui, ma si
                puo' fare in modo che non arrivi a sorpresa: chi legge questa
                riga sa gia' cosa gli verra' chiesto e perche', e sa che
                rispondere di si' e' il passaggio giusto. */}
            <div className="pru-icon">{saltoInCorso ? '🔓' : '💳'}</div>
            <p className="pru-pitch">{saltoInCorso ? t('salto_chrome_titolo') : t('auto_checkout_loading')}</p>
            {saltoInCorso && <p className="pru-nota-salto">{t('salto_chrome_nota')}</p>}
            <p className="cps-garanzia-riga"><span aria-hidden="true">🛡️</span>{t('garanzia_riga')}</p>
          </>
        )}
        {error && (
          <>
            <div className="auth-error">⚠ {error}</div>
            <div className="pru-actions" style={{ marginTop: 16 }}>
              <button type="button" className="pru-btn-primary" onClick={buy2tb} disabled={loading}>
                {t('auto_checkout_retry')}
              </button>
              <button type="button" className="pru-btn-secondary" onClick={onFallbackFree}>
                {t('free_cta')}
              </button>
            </div>
          </>
        )}
      </div>

      {inAppWarningProps && <InAppBrowserWarning {...inAppWarningProps} />}
    </div>
  );
}
